<script setup>
import { validationCheck } from '@utils'

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useServiceItem } from '@store/serviceItem'
const $serviceItem = useServiceItem()

import { useRouter,useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

import Main from './Main.vue'
// import BusinessProfileInformation from '../settings/BusinessProfileInformation.vue'
import EditGeneral from '@views/service/EditGeneral.vue'
import ButtonBack from './ButtonBack.vue'
import ButtonNext from './ButtonNext.vue'
import { onMounted } from 'vue'


const saveServiceGeneral = async () => {

    // validation
    let { errors } = validationCheck([
        {
            condition: !$serviceItem.service.name,
            message: `${$settings.labels.service?.singular} name is required`
        },
    ])
    if (errors) return

    if ($settings.addons.staffs) {
        router.push({ name: 'onboarding.service.staff' })
    } else {
        router.push({ name: 'onboarding.service.duration' })
    }

}

// onMounted(() => {
//         $serviceItem.resetService()
//         $serviceItem.mountServiceItem()
// })
</script>

<template>
    <Main :title="`Create Your First ${$settings.labels.service?.singular}`" :progress="$settings.addons.staffs ? 33 : 50">
        <EditGeneral />

        <ButtonNext text="Continue" @click="saveServiceGeneral()" class="mt-5" />

        <template #footer>
            <!-- <ButtonBack @click="router.push({ name: 'dashboard' })" /> -->
        </template>
    </Main>
</template>